import {__} from "./__";

export const getExportTypes = () => {
    return {
        excel: __('Excel'),
        pdf: __('Pdf'),
    };
};
